import './WhatIsVerdict.css';

const PILLARS = [
  { icon:'✅', letter:'V', word:'Validated',    color:'#a78bfa', desc:'Every hiring decision backed by validated assessments and explainable AI scoring.' },
  { icon:'📊', letter:'E', word:'Evaluation',   color:'#8b5cf6', desc:'Comprehensive skill evaluation through adaptive tests, aptitude, coding, and interviews.' },
  { icon:'🎯', letter:'R', word:'Recruitment',  color:'#7c3aed', desc:'End-to-end recruitment from job posting to offer — with full workflow automation.' },
  { icon:'🧠', letter:'D', word:'Decisions',    color:'#6d28d9', desc:'AI-powered hiring decisions grounded in data, not gut feel. Defensible and auditable.' },
  { icon:'💡', letter:'I', word:'Intelligent',  color:'#5b21b6', desc:'Machine learning that improves with every hire — smarter recommendations over time.' },
  { icon:'🏆', letter:'C', word:'Competency',   color:'#4c1d95', desc:'Role-specific competency frameworks that go beyond resume screening.' },
  { icon:'📈', letter:'T', word:'Tracking',     color:'#3b0764', desc:'Real-time candidate tracking across every pipeline stage with live dashboards.' },
];

export default function WhatIsVerdict() {
  return (
    <section id="what" className="section-divider">
      <div className="section-wrap">
        <span className="eyebrow">What is VERDICT</span>
        <h2 className="sec-title">Seven words. One complete hiring platform.</h2>
        <p className="sec-sub" style={{marginBottom:'3rem'}}>
          VERDICT isn't an acronym by accident. Every letter represents a core pillar
          of what modern, AI-powered hiring should look like.
        </p>
        <div className="verdict-pillars">
          {PILLARS.map((p,i) => (
            <div key={p.letter} className="vp-card" style={{'--vc':p.color, animationDelay:`${i*0.08}s`}}>
              <div className="vp-card__top">
                <div className="vp-card__letter">{p.letter}</div>
                <div>
                  <div className="vp-card__word">{p.word}</div>
                  <div className="vp-card__icon">{p.icon}</div>
                </div>
              </div>
              <p className="vp-card__desc">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
